import { Reducer } from 'redux';
import { IAction } from '../types';
import LocalStore from '@/utils/store';

const LOCALSTRKEY = 'BASE_LIVE_ANCHOR_TIP';

export interface AnchorTipInfoJson {
  id: number;
  dataId: string;
  desc: string;
  type: number;
  time?: number;
}

const localGameInfo = LocalStore.getValue<AnchorTipInfoJson>(LOCALSTRKEY) || {};

export const anchorTipInfo: AnchorTipInfoJson = {
  id: 0,
  dataId: '',
  desc: '',
  type: 0,
  time: 0,
  ...localGameInfo
};

export const setAnchorTipInfo: (payload: AnchorTipInfoJson) => IAction<AnchorTipInfoJson> = (
  payload: AnchorTipInfoJson
) => ({
  type: 'setAnchorTipInfo',
  payload
});

const anchorTipInfoReducer: Reducer<AnchorTipInfoJson, IAction<any>> = (
  state = anchorTipInfo,
  action: IAction<any>
) => {
  const { type, payload } = action;
  switch (type) {
    case 'setAnchorTipInfo':
      LocalStore.setValue(LOCALSTRKEY, payload);
      return {
        ...payload
      };
    default:
      return state;
  }
};

export default anchorTipInfoReducer;
